const OrderPill = ({status}) => {
    /*
    Possible Statuses:
        Pending Payment
        Processing
        Shipped
        Completed
        On Hold
        Cancelled
        Refunded
        Returned
        Failed
    */
    var statusClass = 'pending';
    switch (status) {
        case 'Completed':
            statusClass = 'active';
            break;
        case 'Failed':
            statusClass = 'error';
            break;
        case 'Returned':
            statusClass = 'special';
            break;
        case 'Pending Payment':
        case 'On Hold':
            statusClass = 'warning';
            break;
        case 'Refunded':
        case 'Cancelled':
            statusClass = '';
            break;
    }
    return (
        <div className={`status-pill ${statusClass}`}>
            {status}
        </div>
    )
};

export default OrderPill;